var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input d-flex"},[_c('input',{attrs:{"type":_vm.hidden ? 'password' : 'text'},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('i',{class:['mdi', _vm.hidden ? 'mdi-eye-closed' : 'mdi-eye'],on:{"click":function($event){_vm.hidden = !_vm.hidden}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }